import { ChangeDetectionStrategy, Component, inject, Input, OnInit, output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, Subscription } from 'rxjs';

import { type ConnectorConfiguration } from '@blaze-shared/connectors-domain';

import { ApiBuilderStore } from '../+state/api-builder.store';
import { ApiBuilderPageComponent } from '../api-builder-page/api-builder-page.component';
import { ApiBuilderAction, ApiBuilderDialogPage } from '../api-builder.model';
import { ApiBuilderService } from '../services/api-builder.service';

@UntilDestroy()
@Component({
  selector: 'blaze-rest-api-connector-dialog',
  imports: [ApiBuilderPageComponent],
  templateUrl: './rest-api-connector-dialog.component.html',
  styleUrls: ['./rest-api-connector-dialog.component.scss'],
  providers: [ApiBuilderStore],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RestApiConnectorDialogComponent implements OnInit {
  private readonly apiBuilderStore = inject(ApiBuilderStore);
  private readonly apiBuilderService = inject(ApiBuilderService);

  connectorUpdated = output<ConnectorConfiguration | undefined>();

  @Input() connector?: ConnectorConfiguration;

  currentPage$: Observable<ApiBuilderDialogPage>;
  actionToEdit$: Observable<ApiBuilderAction | undefined>;
  connectorUpdatedSubscription?: Subscription;

  @Input() set coupledConnector(value: ConnectorConfiguration | null) {
    this.apiBuilderStore.setCoupledConnector(value);
  }

  constructor() {
    const apiBuilderStore = this.apiBuilderStore;
    this.actionToEdit$ = apiBuilderStore.actionToEdit$;
    this.currentPage$ = apiBuilderStore.currentPage$;

    this.connectorUpdatedSubscription = this.apiBuilderService
      .observeConnectorUpdated()
      .pipe(untilDestroyed(this))
      .subscribe((connector) => {
        this.connectorUpdated.emit(connector);
      });
  }

  ngOnInit(): void {
    this.apiBuilderStore.initialize({
      connectorId: this.connector?.id,
      connectorName: this.connector?.name || '',
      ...this.apiBuilderService.mapApiDefinitionToStore(this.connector?.customApiDefinition),
    });
    this.apiBuilderStore.setOriginalConnector(this.connector || null);
  }
}
